  export const REACT_CHRONO_THEME={
    // Couleurs principales
    primary: "#3d805b",
    secondary: "#888888",
  
    // Timeline
    timelineBgColor: "#ffffff",
  
    // Cartes
    cardBgColor: "#ffffff",
    cardForeColor: "#111827",
  
    // Titres
    titleColor: "#ffffff",
    titleColorActive: "#3d805b",
  
    // Carte
    cardTitleColor: "#111827",
    cardSubtitleColor: "#2E6145",
    cardDetailsColor: "#2E6145",
  
    // Détails
    detailsColor: "#2E6145",
    textColor: "#111827",
  
    // Icônes
    iconBackgroundColor: "#3d805b",
    iconColor: "#ffffff",
  
    // Barre d'outils
    toolbarBgColor: "#2E6145",
    toolbarBtnBgColor: "#3d805b",
    toolbarTextColor: "#111827",
  
    // Cartes imbriquées
    nestedCardBgColor: "#f9fafb",
    nestedCardTitleColor: "#111827",
    nestedCardSubtitleColor: "#f00000",
    nestedCardDetailsColor: "#2E6145",
    nestedCardDetailsBackGround: "#ffffff",
  
    // Boutons (Dark mode / UI)
    buttonHoverBgColor: "#e5e7eb",
    buttonActiveBgColor: "#3d805b",
    buttonActiveIconColor: "#ffffff",
  
    buttonBorderColor: "#ffffff",
    buttonHoverBorderColor: "#ffffff",
    buttonActiveBorderColor: "#ffffff",
  
    // Effets
    shadowColor: "rgba(0,0,0,0.15)",
    glowColor: "rgba(59,130,246,0.35)",
  
    // Recherche
    searchHighlightColor: "#fde68a",
  
    // Toggle Dark Mode
    darkToggleActiveBgColor: "#3d805b",
    darkToggleActiveIconColor: "#030303",
    darkToggleActiveBorderColor: "#3d805b",
    darkToggleGlowColor: "#b2fa60",
  }